import styled from 'styled-components';

export const Nav=styled.div`
width:100%;
height:130px;
`
export const Navcontent=styled.div`
display:flex;
`

export const LoginContainer=styled.div`
width:100%;
height:120px;
background-color:#ededed;
`
export const LoginContent=styled.div`
display:flex;
width:600px;
margin:auto;
// margin-top:10px;
`
export const Signupform=styled.div`
// display:flex;
width:500px;
// margin-top:50px;
margin:auto;

`
